import React from 'react'
import { Link } from 'react-router-dom';
import networkSVG from '../assets/network.svg';
import plusSVG from '../assets/plus.svg';
import transferSVG from '../assets/transfer.svg';
import pointSVG from '../assets/point.svg';
import ethSVG from '../assets/ethereum.svg';

function WalletPage() {
    return (
        <div className='wallet-body'>
            <h2 className='heading'>Account Balance</h2>

            <div className='center'>
                <div className='grid w-80'>
                    <div className='balance-card card mt-2'>
                        <div className='balance-header'>
                            <p className='total-value'>TOTAL VALUE</p>
                            <p className='network'><img className='network-svg' src={networkSVG} alt="svg" />Main Ethereum Network</p>
                        </div>
                        <div className='balance-container'>
                            <div className='amount-container'>
                                <span className='amount'><b>0</b></span>
                                <p className='currency'>USD</p>
                            </div>
                            <div>
                                <p className='gray'><b>1 ETH = 3,007.35 USD</b></p>
                            </div>
                        </div>
                        <div className='balance-btns'>
                            <button className='btn'>
                                <img className="btn-svg" src={plusSVG} alt='svg' />
                                <b>Top up</b>
                            </button>
                            <button className='btn'>
                                <img className="btn-svg" src={transferSVG} alt='svg' />
                                <b>Transfer</b>
                            </button>
                        </div>
                    </div>

                    <div className='welcome-card mt-2 card vertical-align'>
                        <p className='welcome-p'>
                            <b>Welcome to Box</b>
                        </p>
                        <p>
                            <Link
                                to="/"
                                className="link"
                                >
                                Learn more
                            </Link>
                            <span className='gray'> about your wallet today. </span>
                        </p>
                    </div>
                </div>

                <div className='collection-container'>
                    <div className='options'>
                        <div>
                            <img className="btn-svg" src={pointSVG} alt='svg' />
                            Tokens
                        </div>
                        <div>
                            Collectibles
                        </div>
                    </div>

                    <div className='grid'>
                        <div className='token-card'>
                            <div className='flex-seperate shadow-btm card-header small-pad'>
                                <p className='v-center'><img className="black-svg" src={ethSVG} alt='svg' /> <b>Ethereum</b></p>
                                <p><b>0 ETH</b></p>
                            </div>
                            <div className='flex-seperate small-pad'>
                                <p className='gray'><b>1 ETH = 3,031.79 USD</b></p>
                                <p><b>0 USD</b></p>
                            </div>
                        </div>

                        <div className='token-card'>
                            <div className='card-header small-pad center shadow-btm'>
                                <b>Did not see your new Token?</b>
                            </div>
                            <div className='flex-seperate small-pad center'>
                            <Link
                                to="/"
                                className="link"
                                >
                                Add Token here
                            </Link>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default WalletPage;